<template>
  <NavBar />
  <notifications position="top right" />
  <div class="fixed inset-0 z-[60] flex items-center justify-center spin-content" v-if="loading">
    <pulse-loader class="" :color="color" :loading="loading"></pulse-loader>
  </div>

  <router-view />

  <FooterView class="mt-10" />
</template>
<script>
import NavBar from '@/components/Default/NavBar.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import FooterView from '@/components/Default/Footer.vue'
export default {
  name: 'AppView',
  data() {
    return {
      home: 'Home',
      color: '#98d1c8'
    }
  },
  components: {
    NavBar,
    FooterView,
    PulseLoader,
  },

  mounted() {
    document.title = "Artblla - Best online Market";
    const dir = this.$i18n.locale === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', this.$i18n.locale);
  },
  watch: {
    '$i18n.locale': {
      handler(locale) {
        const dir = locale === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.setAttribute('dir', dir);
        document.documentElement.setAttribute('lang', locale);
      },
      immediate: true,
    }
  },
  computed: {
    loading() {
      return this.$store.getters.loading
    }
  },

}
</script>

  

